import { useNavigate } from "react-router-dom";

const DASHBOARD_CARDS = [
  {
    title: "Sales Dashboard",
    description: "Supervisor sales trends, territory health, employees, and coverage details.",
    path: "/dashboard/sales",
  },
  {
    title: "Brand Dashboard",
    description: "Brand performance, territory drilldowns, stockists, doctors, and coverage.",
    path: "/dashboard/brand",
  },
  {
    title: "AI Sales Diagnosis",
    description: "Root-cause signals, employee diagnosis, missed doctors, and nudges.",
    path: "/dashboard/diagnosis",
  },
  {
    title: "Division Performance",
    description: "Division, BDM, HQ, brand, stockist, and monthly performance views.",
    path: "/dashboard/division-performance",
  },
  {
    title: "Sales Force Effectiveness",
    description: "HQ productivity, PCPM bands, growth spread, volatility, and credit-note leakage.",
    path: "/dashboard/sfe",
  },
  {
    title: "Efforts Dashboard",
    description: "Field rep effort tracking, coverage, compliance, and activity trends.",
    path: "/dashboard/efforts",
  },
  {
    title: "Field Sales Dashboard",
    description: "HQ and TM productivity, target achievement, PCPM bands, critical HQs, and volatility.",
    path: "/dashboard/field-sales",
  },
  {
    title: "Executive Focus Note",
    description: "Evidence-backed executive focus points, critical alert tables, and citations.",
    path: "/dashboard/executive-focus-note",
  },
  {
    title: "Semantic Query",
    description: "Ask business questions against the Emcure semantic model and explore the returned data.",
    path: "/dashboard/semantic-query",
  },
  {
    title: "Chat",
    description: "Open the AI assistant chat workspace.",
    path: "/chat",
  },
];

export default function FridayDashboardHome() {
  const navigate = useNavigate();

  return (
    <section className="friday-dashboard-home">
      <div className="friday-dashboard-home-content">
        <h1>Sales & Marketing Dashboard</h1>
        <p>
          Choose an access-enabled Sales & Marketing workspace. These routes use the same supervisor access gate as the existing dashboard windows.
        </p>

        <div className="friday-dashboard-card-grid">
          {DASHBOARD_CARDS.map((item) => (
            <button
              key={item.path}
              type="button"
              className="friday-dashboard-card"
              onClick={() => navigate(item.path)}
            >
              <strong>{item.title}</strong>
              <span>{item.description}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
